import {useParams} from 'react-router-dom'
import {useGetUserDancesQuery, useI18n} from 'store/Store'

const useUserPendingDancesRequests = () => {
    const {i18n} = useI18n()
    const {choreographerId} = useParams()
    const {data: pendingDances, isSuccess: dancesSuccess} =
        useGetUserDancesQuery({
            filter: 'withPendingMediaOnly=true',
            choreographerId,
        })

    const translationLabel = 'user.requests.'
    const t = (label, input) => i18n.t(translationLabel + label, input)

    const pageTitle = t('title')

    return {
        noDances: pendingDances?.length === 0,
        dancesSuccess,
        pendingDances,
        pageTitle,
        t,
    }
}

export default useUserPendingDancesRequests
